export const emptyAgenda = () => ({ items: [], versions: {}, count: 0, countSequence: 0 });

export const agendaReducer = (state, action) => {
  if (action.type === "RESET") return emptyAgenda();
  if (!["LOAD", "CHANGES"].includes(action.type)) return state;
  const versions = { ...state.versions };
  const rows = new Map(state.items.map(row => [row.id, row]));
  const ids = action.type === "CHANGES" ? action.ids : action.contacts.map(row => row.id);
  const incoming = new Map(action.contacts.map(row => [row.id, row]));
  for (const id of ids) {
    if ((versions[id] || 0) > action.sequence) continue;
    versions[id] = action.sequence;
    const row = incoming.get(id);
    if (row) rows.set(id, row); else rows.delete(id);
  }
  const items = [...rows.values()].sort((a, b) => String(a.name || "").localeCompare(String(b.name || ""), "pt-BR", { sensitivity: "base" }) || a.id - b.id);
  return { items, versions,
    count: action.sequence >= state.countSequence ? action.count : state.count,
    countSequence: Math.max(action.sequence, state.countSequence) };
};

export const createAgendaChangeQueue = ({ load, onResult, onError, onOverflow, schedule = setTimeout, cancel = clearTimeout }) => {
  const ids = new Set(); let timer; let running = false; let active = true;
  const requestFlush = () => { if (active && !running && !timer && ids.size) timer = schedule(flush, 350); };
  const flush = async () => {
    timer = null; if (!active || running || !ids.size) return;
    running = true;
    const batch = [...ids].slice(0, 50); batch.forEach(id => ids.delete(id));
    try {
      const result = await load(batch);
      if (active) onResult(batch, result);
    } catch (error) { if (active) onError(error); }
    finally { running = false; requestFlush(); }
  };
  return {
    add(id) {
      if (!active || !Number.isInteger(Number(id)) || Number(id) < 1) return;
      if (ids.size >= 500) { ids.clear(); onOverflow(); return; }
      ids.add(Number(id)); requestFlush();
    },
    dispose() { active = false; ids.clear(); if (timer) cancel(timer); }
  };
};
